<div
    class="layout-wrapper"
    (click)="onLayoutClick()"
    [ngClass]="{
        'menu-layout-static': !isOverlay(),
        'menu-layout-overlay': isOverlay(),
        'layout-menu-overlay-active': overlayMenuActive,
        'menu-layout-horizontal': isHorizontal(),
        'menu-layout-slim': isSlim(),
        'layout-menu-static-inactive': staticMenuDesktopInactive,
        'layout-menu-static-active': staticMenuMobileActive
    }"
>
    <div class="ef-wrapper">
        <app-layout  [processes]="processes"
        [processTitles]="processTitles"
        [user]="user$ | async"
        [userInfo]="userInfo$ | async"
        [roles]="userRoles$ | async"
        [roleDrivenModel]="roleDrivenModel"></app-layout>
        <!-- <ef-toaster-container></ef-toaster-container>
        <app-topbar
            [processes]="processes"
            [processTitles]="processTitles"
            [user]="user$ | async"
            [userInfo]="userInfo$ | async"
            [roles]="userRoles$ | async"
        ></app-topbar>

        <div
            class="layout-menu-container"
            [ngClass]="{
                'layout-menu-dark': darkMenu,
                'layout-menu-light': !darkMenu
            }"
            (click)="onMenuClick($event)"
            style="width: 5rem !important;"
        >
            <p-scrollPanel #layoutMenuScroller [style]="{ height: '100%', width: '5rem' }">
                <div class="menu-scroll-content" style="width: 5rem !important;">
                    <app-inline-profile
                        *ngIf="profileMode == 'inline' && !isHorizontal()"
                    ></app-inline-profile>
                    <app-menu [reset]="resetMenu"></app-menu>
                </div>
            </p-scrollPanel>

            <app-message-menu></app-message-menu>
            <app-detail-menu></app-detail-menu>
        </div>

        <div class="layout-main">
            <ui-view></ui-view>
        </div>

        <div class="layout-mask"></div>-->
    </div>
    <!-- <app-footer></app-footer>  -->
    <!-- <p-drawer
        [(visible)]="ReportsSideNavVisible"
        style="min-width: 35vw; max-width: 90vw; width: 50vw; height: 100vh;"
        position="right"
        [modal]="true"
        appendTo="body"
        baseZIndex="2000"
        [blockScroll]="true"
        [showCloseIcon]="false"
        (onHide)="onReportsSideNavHide()"
        (onShow)="onReportsSideNavShow()"
    >


    </p-drawer> -->

    <ef-reporting-feature #reportsSideNav></ef-reporting-feature>

    <p-confirmDialog key="global-error-dialog" [style]="{'z-index': '10000'}"></p-confirmDialog>

    <div
        *ngIf="isUserAuthenticated && showAIHelpButton && showFloatingExpertLauncher && !showFloatingExpertChat"
        class="floating-expert-launcher-cluster"
    >
        <button
            class="floating-expert-dismiss"
            type="button"
            (click)="dismissFloatingExpertLauncher($event)"
            aria-label="Hide"
            title="Hide"
        >
            <i class="pi pi-times" aria-hidden="true" style="font-size: 0.8rem;"></i>
        </button>
        <button
            class="floating-expert-launcher"
            type="button"
            (click)="openFloatingExpertChat($event)"
            [attr.aria-expanded]="showFloatingExpertChat"
            aria-label="Ask eFAACT"
            title="Ask eFAACT"
        >
            <!-- <img src="../../../images/efaact_ai_logo.png" alt="eFAACT Expert" style="width: 45px; height: 45px;"> -->
            <i class="pi pi-sparkles" aria-hidden="true" style="font-size: 2rem;"></i>
        </button>
    </div>

    <div
        *ngIf="isUserAuthenticated && showAIHelpButton && showFloatingExpertLauncher && floatingExpertChatMounted"
        class="floating-expert-panel"
        [class.floating-expert-panel--open]="showFloatingExpertChat"
        [attr.aria-hidden]="!showFloatingExpertChat"
        [ngStyle]="floatingExpertPanelSizeStyle"
        (click)="$event.stopPropagation()"
    >
        <ef-chat
            [floatingPanel]="true"
            (closeFloatingPanel)="closeFloatingExpertChat()"
        ></ef-chat>
        <ng-container *ngIf="showFloatingExpertChat">
            <div
                class="floating-expert-panel-resize-handle floating-expert-panel-resize-handle--nw"
                (pointerdown)="onFloatingExpertPanelResizeStart($event, 'nw')"
            ></div>
            <div
                class="floating-expert-panel-resize-handle floating-expert-panel-resize-handle--ne"
                (pointerdown)="onFloatingExpertPanelResizeStart($event, 'ne')"
            ></div>
            <div
                class="floating-expert-panel-resize-handle floating-expert-panel-resize-handle--sw"
                (pointerdown)="onFloatingExpertPanelResizeStart($event, 'sw')"
            ></div>
            <div
                class="floating-expert-panel-resize-handle floating-expert-panel-resize-handle--se"
                (pointerdown)="onFloatingExpertPanelResizeStart($event, 'se')"
            ></div>
        </ng-container>
    </div>
</div>
